/* import __COLOCATED_TEMPLATE__ from './pdf-modal.hbs'; */
import { action, computed } from '@ember/object';
import { classNames } from '@ember-decorators/component';
import { loadRenderedPdf, printPdf } from 'client-portal/utils/pdf';
import { namespace } from 'client-portal/adapters/application';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './pdf-modal.module.scss';

@classic
@classNames(styles.component)
export default class SiteBillingPdfModal extends Component {
  @service media;
  @service billingModals;
  @service billingPaymentCoordinator;
  @service fastboot;

  @service store;

  @computed('model.cursorId')
  get pdfUrl() {
    return this._pdfUrl();
  }

  @computed('model.cursorId')
  get downloadPdfUrl() {
    return `${this._pdfUrl()}?download=true`;
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    this._loadPdf();

    this.billingModals.afterPersist.push(() => {
      return this.store.queryRecord('polymorphic/billing-item', { cursorId: this.model.cursorId });
    });
    this.billingModals.afterPersist.push(() => {
      this._loadPdf();
    });
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    this.billingModals.afterPersist.pop();
    this.billingModals.afterPersist.pop();
  }

  @action
  reloadPdf() {
    this._loadPdf();
  }

  @action
  printModel() {
    printPdf(this.pdfUrl);
  }

  @action
  downloadModel() {
    window.open(this.downloadPdfUrl);
  }

  _loadPdf() {
    // PDF.js needs a real document/canvas/worker. FastBoot should not SSR PDFs.
    // Do not stub `document` on the FastBoot sandbox to paper over that —
    // jQuery then calls `createElement` on the stub and SSR still 500s.
    if (this.fastboot?.isFastBoot) {
      return;
    }

    // Clean up if we need to re-render
    this.element.querySelector('.pdf-container canvas')?.remove();
    // Fire-and-forget: payment afterPersist awaits every hook.
    void loadRenderedPdf(this, this.pdfUrl, this.element.querySelector('.pdf-container'));
  }

  _pdfUrl() {
    return `/${namespace}/billing-items/${encodeURIComponent(this.model.cursorId)}.pdf`;
  }
}
